module.exports = __webpack_public_path__ + "static/media/twitter.edf284b4.svg";